<script>
import { twoFactorAuthMethods, authMethods } from '@state/helpers'

export default {
  name: 'CodeVerification',
  props: {
    credentials: {
      type: Object,
      default: { username: '', password: ''}
    },
    authOption: {
      type: String,
      default: ''
    }
  },
  components: { 
  },
  data() {
    return {
      sendingEmail: false,
      tryingToVerifyToken: false,
      otpToken: '',
      isValidInput: true,
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null;
    },
    getA2fText() {
      if(this.authOption === 'email') {
        return this.$t('a2f_section.email');
      } else if(this.authOption === 'totp') {
        return this.$t('a2f_section.totp');
      }
      return '';
    }
  },
  methods: {
    ...twoFactorAuthMethods,
    ...authMethods,

    sendEmail() {
      console.log('sendEmail')
      this.sendingEmail = true;
      this.sendEmailAuth(this.credentials)
        .then((response) => { 
          console.log(response); 
          this.sendingEmail = false;
          this.$generate_toast(this, 'success',
            this.$t('a2f_section.token_sent_correctly'))
        })
        .catch((error) => { 
          console.log(error);
          this.sendingEmail = false;
          this.$generate_toast(this, 'error', 'error')
        })
    },

    tryToVerifyToken() {
      this.tryingToVerifyToken = true;
      this.authError = null; // Reset the authError if it existed.
      console.log('token:', this.otpToken);
      
      this.logInTwoFactor({ ...this.credentials, code: this.otpToken, 
        authOption: this.authOption })
        .then((data) => {
          console.log(data)
          this.tryingToVerifyToken = false;
          if(Object(data.user.user_info).hasOwnProperty('is_first_login') && data.user.user_info.is_first_login) {
            this.$emit('firstLogin');
          } else {
            this.$emit('loggedIn');
          }
        })
        .catch((error) => {
          console.error("error:", error)
          this.tryingToVerifyToken = false;
          if(error.response.status == 400) {
            this.$generate_toast( this, 'error',
              this.$t('a2f_section.token_expired_or_invalid'))
            return;
          }
          this.$generate_toast( this, 'error',
            this.$t('a2f_section.unknown_error'))
        })
    },
  },
}
</script>

<template>
  <div class="text-center m-auto p-3 otp">
    <div class="w-75 m-auto">
      <a href="/">
        <span
          ><b-img
            v-if="getCompanyInfo"
            :src="getCompanyInfo['dark_logo'] || require('@assets/images/logos/logo-dark.png')"
            alt="login"
            class="p-1 pb-2"
            fluid
        /></span>
      </a>
    </div>
    <div class="text-dark mb-2">
      {{ getA2fText }}
    </div>
    <div class="h5 text-dark" v-if="authOption==='email'">
      {{ credentials.username }}
    </div>
    <b-form @submit.prevent="tryToVerifyToken">
      <b-form-input v-model="otpToken" placeholder="Ingresar token" type="number"
        required min="0"
      />
      <div v-if="authOption==='email'">
        <b-button
          size="xs"
          :disabled="sendingEmail"
          variant="transparent"
          class="text-dark mt-2"
          @click="sendEmail"
        >
          <b-spinner v-if="sendingEmail" small class="align-middle"></b-spinner>
          <span>
            {{ sendingEmail ? $t('a2f_section.sending_token') : $t('a2f_section.resend_token') }}
          </span>
        </b-button>
      </div>
      <b-button
        type="submit"
        block
        variant="primary"
        class="mt-4"
        :disabled="tryingToVerifyToken"
      >
        <div v-if="tryingToVerifyToken">
          <b-spinner small></b-spinner>
        </div>
        <div v-else>Verify</div>
      </b-button>
    </b-form>
  </div>
</template>

<style lang="scss" module></style>
